// Author YuJiaBei
// Date 2020-11-12 10:33:16

import * as model from "@/model/em/inspection/InspectionValueTypeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionValueType(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL,
    })
    .buildStore()
